import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import CustomCalendar from "../../components/elements/custom-calendar";
import { Button } from "antd";

const TIME_SLOTS = [
  "9:00am - 9:15am",
  "9:25am - 9:40am",
  "9:50am - 10:05am",
  "10:15am - 10:30am",
  "10:40am - 10:55am",
];

export default function Reschedule() {
  const navigate = useNavigate();
  const [schedule, setSchedule] = useState<any>(null);
  const [time, setTime] = useState<string | null>(null);

  function onProceed() {
    // TODO: wire to API when ready
  }

  return (
    <div className="min-h-full bg-medpharma-mist/40">
      <div className="mx-auto max-w-2xl">
        <div className="mb-6">
          <Button
            type="text"
            onClick={() => navigate(-1)}
            className="flex items-center gap-2 text-primary-blue hover:!text-primary-blue/80 -ml-2"
            aria-label="Go back"
          >
            Back
          </Button>
        </div>

        <div className="rounded-2xl border border-slate-200/80 bg-white shadow-card overflow-hidden">
          <div className="border-b border-slate-200/80 bg-slate-50/50 px-6 py-4">
            <h1 className="text-lg font-semibold text-slate-800 tracking-tight">
              Reschedule appointment
            </h1>
            <p className="mt-1 text-sm text-slate-500">
              Choose a new date and time slot
            </p>
          </div>

          <div className="p-6 space-y-6">
            <div>
              <h2 className="text-sm font-semibold text-slate-700 mb-3">
                New date
              </h2>
              <CustomCalendar
                setSchedule={setSchedule}
                schedule={schedule}
              />
            </div>

            <div>
              <h2 className="text-sm font-semibold text-slate-700 mb-3">
                Time slot
              </h2>
              <div className="flex flex-wrap gap-2">
                {TIME_SLOTS.map((slot) => (
                  <button
                    key={slot}
                    type="button"
                    onClick={() => setTime(slot)}
                    className={`rounded-xl border px-4 py-2.5 text-sm font-medium transition-all focus:outline-none focus:ring-2 focus:ring-primary-blue/40 ${
                      time === slot
                        ? "border-primary-blue bg-primary-blue/10 text-primary-blue"
                        : "border-slate-200 text-slate-600 hover:border-slate-300 hover:bg-slate-50"
                    }`}
                  >
                    {slot}
                  </button>
                ))}
              </div>
            </div>

            <div className="flex flex-col-reverse sm:flex-row gap-3 pt-2">
              <Button
                size="large"
                onClick={() => navigate(-1)}
                className="w-full sm:w-auto"
              >
                Back
              </Button>
              <Button
                type="primary"
                size="large"
                onClick={onProceed}
                className="w-full sm:flex-1 !bg-primary-blue hover:!bg-primary-blue/90"
              >
                Save new schedule
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
